import { Typography } from '@mui/material'
import { AddLine } from './full-width-button.styles'

interface IProps {
  buttonText: string
  handleAddLine: () => void
}

const FullWidthButton = ({ buttonText, handleAddLine }: IProps) => {
  return (
    <AddLine onClick={handleAddLine}>
      <Typography fontWeight={700} color="primary.main">
        {buttonText}
      </Typography>
    </AddLine>
  )
}

export default FullWidthButton
